import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { SessionExpiredBanner } from "../components/SessionExpiredBanner";

interface SessionContextType {
  showSessionExpired: () => void;
  expired: boolean;
}

const SessionContext = createContext<SessionContextType | undefined>(undefined);

let externalTrigger: (() => void) | null = null;

export const SessionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    if (
      sessionStorage.getItem("hadSession") &&
      !localStorage.getItem("accessToken")
    ) {
      setExpired(true);
    }
  }, []);

  useEffect(() => {
    if (expired && localStorage.getItem("accessToken")) {
      setExpired(false);
      sessionStorage.removeItem("hadSession");
    }
  }, [expired]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (localStorage.getItem("accessToken")) {
        setExpired(false);
        sessionStorage.removeItem("hadSession");
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const showSessionExpired = () => {
    setExpired(true);
  };

  externalTrigger = showSessionExpired;

  return (
    <SessionContext.Provider value={{ showSessionExpired, expired }}>
      {expired && (
        <SessionExpiredBanner message="Session expired. Please log in again." />
      )}
      {children}
    </SessionContext.Provider>
  );
};

export const useSessionContext = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSessionContext must be used inside SessionProvider");
  }
  return context;
};

export const triggerSessionExpired = () => {
  if (externalTrigger) {
    externalTrigger();
  }
};
